"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(unit, count) {
    var range;
    var time = {};
    time.millisecond = 1;
    time.second = time.millisecond * 1000;
    time.minute = time.second * 60;
    time.hour = time.minute * 60;
    time.day = time.hour * 24;
    time.week = time.day * 7;
    time.month = time.day * 30;
    time.year = time.day * 365;
    range = time[unit] * count;
    return range;
}
exports.default = default_1;
//# sourceMappingURL=rangeHelper.js.map